"use client";

import { useEffect } from "react";
import useCountDown from "../../hooks/useCountDown";
import dayjs from "dayjs";
import { Text } from "../ui/text";
import { FormattedMessage } from "react-intl";

/**
 * @typedef {object} Props
 * @prop {string} expiresAt
 */
/**
 * @param {Props} props
 */
export function TwoFactorAuthChallengeCountDownCountDown({ expiresAt }) {
  const countdown = useCountDown();

  useEffect(() => {
    if (expiresAt) {
      const timeLeft = dayjs(expiresAt).diff(dayjs(), "second");
      countdown.start(timeLeft);
    }
  }, [countdown, expiresAt]);

  if (countdown.timeLeft === 0) {
    return null;
  }

  return (
    <Text textStyle="text-xs" textAlign="center" color="gray.600">
      <FormattedMessage
        defaultMessage="Cette vérification expire dans {timeLeft} secondes."
        values={{ timeLeft: countdown.timeLeft }}
      />
    </Text>
  );
}
